var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZeroEightStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3418 5.18333L14.3751 5.53333C15.1085 5.59167 15.4001 6.50833 14.8418 6.99167L11.7835 9.64167L12.7001 13.5833C12.8668 14.3 12.0918 14.8667 11.4585 14.4833L8.00012 12.3917L4.54179 14.475C3.90845 14.8583 3.13346 14.2917 3.30012 13.575L4.21679 9.64167L1.15845 6.99167C0.600121 6.50833 0.900122 5.59167 1.63346 5.53333L5.65845 5.19167L7.23346 1.475C7.51679 0.8 8.48346 0.8 8.76679 1.475L10.3418 5.18333ZM13.0751 6.76667L9.42512 6.45V11.6951L11.1418 12.7333L10.3085 9.16667L13.0751 6.76667Z",
    fill: "url(#paint0_linear_half_star)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_half_star",
    x1: 8.00134,
    y1: 0.96875,
    x2: 8.00134,
    y2: 14.6069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBC14"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroEightStar);
export default __webpack_public_path__ + "static/media/zero-eight-star.0ab3d358.svg";
export { ForwardRef as ReactComponent };